const checkImage = () => {
  const $img = $('.shop_visual_box.shop_visual_img img');

  if ($img.length > 0) {
    // 이미지 있음
    $('.shop_visual').show();
    $('.collection-hero.color-scheme-1').hide();

    clearInterval(imageInterval); // 
  } else {
    // 이미지 없음
    $('.shop_visual').hide();
    $('.collection-hero.color-scheme-1').addClass('show');
  }
};

const imageInterval = setInterval(checkImage, 100);
